export default {
  mpc: {
    id: 'excellent-mpc',
    instructionInfo: [
      '例如在广告投放系统中，多个广告商希望共同分析用户行为数据，找出最佳投放策略，而这个时候每个广告商不愿意将己方具体的数据信息泄露给其他广告商，这个时候可以使用多方安全计算，不同广告商通过对各自的信息加密，只有所有人一起参与的时候才可以计算最佳投放策略，单独的广告商不会对其产生影响，且不同广告商无法获取其他广告商的信息，这样就可以帮助他们在不泄露各自数据的情况下完成这一目标。'
    ]
  },
  paillier: {
    id: 'excellent-paillier',
    instructionInfo: [
      '例如在链上环境中，同态加密可以用于保护用户的隐私数据。用户可以将敏感数据例如存款等进行同态加密，并将其存储在链上。在需要进行计算时，可以使用同态计算对密文进行计算，而无需解密原始数据。这样可以保护用户的数据隐私，同时实现在加密数据上的计算操作。'
    ]
  },
  hibe: {
    id: 'excellent-hibe',
    instructionInfo: [
      '在企业内部，不同的员工可能需要访问不同级别的敏感信息或资源。通过分层身份加密，可以为每个员工分配相应的身份层级，并使用相应的加密密钥对敏感信息进行加密。比如老板可以为下属的一级员工、二级员工分配密钥，一级员工也可以为二级员工分配密钥，一级员工可以查看自己层级和下属层级对应的密文信息，而二级员工只能查看自己所属层级的密文信息等。也就是说只有拥有足够高等级密钥的员工才能解密和访问对应的敏感信息。这样可以确保只有授权人员可以访问敏感数据，提高信息安全性。'
    ]
  },
  bulletproofs: {
    id: 'excellent-bullet-proofs',
    instructionInfo: [
      '例如在资产交换领域，零知识证明可用于保护交易方的隐私。发送方可以使用零知识证明向网络证明自己有足够的资金来完成交易，而无需披露账户余额或具体的交易金额；同样发送方也可以使用零知识证明来证明自己的用户信息是真的，例如生日是在某个范围内，但是不需要具体透露给对方等等。这样做的意义就是保护交易中发送者的隐私，使得交易更加可靠、安全。'
    ]
  }
}
